<template>
  <div class="how-to-order bg--color-08">
    <div class="container-wrapper bg--color-01">
      <div class="how-to-order__container container-new">
        <h2 class="how-to-order__title txt--color-05 txt--36px txt--58px--l txt--weight-700 txt--height-44px txt--height-58px--l mb-24 mb-60--l">
          {{ $t('cryptoCards.howToOrder.title') }}
        </h2>
        <div class="how-to-order__items">
          <div
            v-for="(item, i) in items"
            :key="i"
            class="how-to-order__item bg--color-02 bor--radius-20 p-16"
          >
            <component :is="`icon${i}`" class="how-to-order__item-icon" />
            <p class="txt--16px txt--26px--l txt--weight-700 txt--height-20px txt--height-34px--l txt--color-04 mb-0">
              {{ item.title }}
            </p>
            <exc-button v-if="item.withBtn" class="how-to-order__btn" outline size="xs" @click="scrollToTopSection()">
              {{ $t('cryptoCards.howToOrder.linkOnOrderText') }}
            </exc-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '../common'

export default {
  name: 'HowToOrder',
  components: {
    ExcButton,
    icon0: () => import('@/assets/icons/crypto-cards/how-to-order/0.svg?inline'),
    icon1: () => import('@/assets/icons/crypto-cards/how-to-order/1.svg?inline'),
    icon2: () => import('@/assets/icons/crypto-cards/how-to-order/2.svg?inline'),
    icon3: () => import('@/assets/icons/crypto-cards/how-to-order/3.svg?inline'),
  },
  computed: {
    isMobile () {
      return this.$mq?.resize && this.$mq?.below(760)
    },
    items () {
      return [
        {
          title: this.$t('cryptoCards.howToOrder.list.0'),
        },
        {
          title: this.$t('cryptoCards.howToOrder.list.1'),
        },
        {
          title: this.$t('cryptoCards.howToOrder.list.2'),
          withBtn: true,
        },
        {
          title: this.$t('cryptoCards.howToOrder.list.3'),
        },
      ]
    },
  },
  methods: {
    scrollToTopSection () {
      process.client &&
      setTimeout(() => {
        if (window) window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.how-to-order {

  &__title {
    @include bp(l) {
      text-align: center;
    }
  }

  &__items {
    display: grid;
    gap: toRem(16px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
      gap: toRem(24px);
    }
  }

  &__item {
    display: flex;
    align-items: center;
    gap: toRem(12px);

    @include bp(l) {
      gap: toRem(35px);
    }
  }

  &__item-icon {
    display: block;
    min-width: toRem(48px);

    @include bp(l) {
      min-width: toRem(120px);
      width: toRem(120px);
      height: toRem(108px);
    }
  }

  &__btn {
    width: max-content;
    min-width: max-content;
  }
}
</style>
